<template>
  <router-link :to="to" class="flex py-2.5 px-5 rounded-full transition ease-in-out">
    <slot></slot>
    <span class="hidden">{{ name }}</span>
  </router-link>
</template>

<script>
export default {
  name: "BottomNavigationItem",
  props: ['to', 'name']
}
</script>

<style scoped>
.router-link-exact-active {
  @apply bg-green-500 text-white
}

.router-link-exact-active span {
  @apply block
}
</style>